import { useEffect, useState } from "react";
import columns from "../../../../columns/recentTransaction";
import TableWithSkeleton from "../../../../components/table/TableWithSkeleton";
import MySegmented from "../../../../components/segmented/Segmented";
import Badge from "../../../../components/common/Badge";
import { formatDate } from "../../../../utils/utils";

const RecentTable = ({ data }) => {
    const [type, setType] = useState("Deposit");
    const [filteredData, setFilteredData] = useState([]);

    useEffect(() => {
        const transactionData = type === "Deposit" ? data?.lastFiveDeposit : data?.lastFiveWithdrawal;

        setFilteredData(transactionData?.map((item) => {
            return ({
                ...item,
                amount: `$ ${item?.amount}`,
                transactionDate: formatDate(item?.transactionDate),
                status: <Badge type={item?.transactionStatus === "Success" ? 'success' : 'error'} text={item?.transactionStatus} />,
            })
        }));
    }, [type, data]);

    return (
        <div className='border-2 border-light rounded-[10px] p-5 h-full'>
            <div className="flex flex-wrap items-center justify-between gap-5">
                <h2 class="text-lg font-semibold">Recent Transactions</h2>
                <MySegmented options={["Deposit", "Withdraw"]} value={type} setValue={setType} />
            </div>

            <div className="mt-5">
                <TableWithSkeleton columns={columns} data={filteredData} />
            </div>
        </div>
    )
}

export default RecentTable;
